import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

import type { RootState } from '../index'

interface PendingInjection {
  dischargeNotes: string | null
  medicalNotes: string | null
  soapId: string
}

interface AudioRecorderInjectionState {
  pendingInjection: PendingInjection | null
}

const initialState: AudioRecorderInjectionState = {
  pendingInjection: null,
}

const audioRecorderInjectionSlice = createSlice({
  name: 'audioRecorderInjection',
  initialState,
  reducers: {
    setPendingInjection: (state, action: PayloadAction<PendingInjection>) => {
      state.pendingInjection = action.payload
    },
    clearMedicalNotesInjection: (state) => {
      if (state.pendingInjection) {
        state.pendingInjection.medicalNotes = null
        // Clear entire object if both are consumed
        if (!state.pendingInjection.dischargeNotes) {
          state.pendingInjection = null
        }
      }
    },
    clearDischargeNotesInjection: (state) => {
      if (state.pendingInjection) {
        state.pendingInjection.dischargeNotes = null
        // Clear entire object if both are consumed
        if (!state.pendingInjection.medicalNotes) {
          state.pendingInjection = null
        }
      }
    },
    clearPendingInjection: (state) => {
      state.pendingInjection = null
    },
  },
})

export const {
  setPendingInjection,
  clearMedicalNotesInjection,
  clearDischargeNotesInjection,
  clearPendingInjection,
} = audioRecorderInjectionSlice.actions

export default audioRecorderInjectionSlice.reducer

// Selectors
export const getPendingInjection = (
  state: RootState,
): PendingInjection | null => state.audioRecorderInjection.pendingInjection
